define([
    'lib/config'
], function (config) {
    var audienceScienceGatewayUrl = '//js.revsci.net/gateway/gw.js?csid=F09828&auto=t&bpid=theguardian';

    return {
        shouldRun: config.page.edition === 'UK' && config.switches.audienceScienceGateway,
        url: audienceScienceGatewayUrl
    };

});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/third-party-tags/audience-science-gateway.js
// module id = 808
// module chunks = 1